// Global settings for the website
const settings = {
  // Site Information
  siteName: "THE ASIAN INTERNATIONAL SCHOOL",
  tagline: "Leading CBSE School in Hyderabad | Primary to High School Education",
  fullName: "THE ASIAN INTERNATIONAL SCHOOL - Primary, Middle & High School in Hyderabad",

  // Branding
  logo: "/logo.png",
  favicon: "/favicon.png",

  // Contact Information
  address: {
    street: "5-7-22/1, Sangeethnagar",
    city: "Kukatpally, Hyderabad",
    zipCode: "500072",
    full: "5-7-22/1, Sangeethnagar, Kukatpally, Hyderabad – 500072"
  },

  phones: [
    { number: "+918106921133", display: "81069 21133" }
  ],

  email: "theasianinternationalschool@gmail.com",

  whatsapp: {
    number: "918106921133",
    link: "https://wa.me/918106921133"
  },

  // Operating Hours
  hours: {
    weekdays: "Mon – Fri: 08:30 AM – 03:30 PM",
    note: "Saturday & Govt Holidays: Closed"
  },

  // Social Media Links (add URLs when available)
  socialMedia: {
    facebook: "https://facebook.com/theasianinternationalschool",
    instagram: "https://instagram.com/theasianinternationalschool",
    twitter: "https://twitter.com/theasianinternationalschool",
    linkedin: "https://linkedin.com/company/theasianinternationalschool",
    youtube: "https://youtube.com/theasianinternationalschool"
  },

  // SEO Meta Information
  meta: {
    title: "THE ASIAN INTERNATIONAL SCHOOL | Best CBSE School in Hyderabad | Primary to High School",
    description: "The Asian International School in Kukatpally, Hyderabad offers high-quality CBSE education from primary to high school with a focus on academic excellence, innovation, leadership, and holistic student development.",
    keywords: "CBSE school Hyderabad, best school in Kukatpally, top CBSE school Hyderabad, primary school Hyderabad, middle school Hyderabad, high school Hyderabad, academic excellence Hyderabad, CBSE curriculum Telangana, modern education Hyderabad, international standard school Hyderabad",
    author: "THE ASIAN INTERNATIONAL SCHOOL",
    ogImage: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&h=630&fit=crop&crop=center",
    url: "https://theasianinternationalschool.com",
    ogType: "website",
    twitterCard: "summary_large_image",
    locale: "en_IN",
    robots: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1",
    googlebot: "index, follow",
    canonical: "https://theasianinternationalschool.com"
  },

  // Page-specific SEO Meta Information
  pageMeta: {
    home: {
      title: "THE ASIAN INTERNATIONAL SCHOOL | Leading CBSE School in Hyderabad",
      description: "The Asian International School in Kukatpally, Hyderabad provides quality CBSE education from primary to high school with experienced faculty, modern classrooms, and a focus on academic excellence.",
      keywords: "CBSE school Hyderabad, best school Kukatpally, top school Hyderabad, primary to high school Hyderabad, quality education Telangana"
    },
    about: {
      title: "About THE ASIAN INTERNATIONAL SCHOOL | Vision & Academic Excellence",
      description: "Learn about THE ASIAN INTERNATIONAL SCHOOL's mission to provide quality CBSE education, academic excellence, leadership skills, and holistic development for students in Hyderabad.",
      keywords: "about CBSE school Hyderabad, school mission vision Telangana, academic excellence school Hyderabad, student development Kukatpally"
    },
    academics: {
      title: "Academics 2026 | CBSE Curriculum | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "Join THE ASIAN INTERNATIONAL SCHOOL for academic year 2026. CBSE curriculum from primary to high school with expert faculty, innovative learning, and student-centered education.",
      keywords: "CBSE academics Hyderabad, CBSE school admission 2026, school enrollment Hyderabad, academic excellence Telangana"
    },
    awards: {
      title: "Awards & Recognition | Academic Excellence | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "THE ASIAN INTERNATIONAL SCHOOL is recognized for excellence in education, quality learning environment, and commitment to student success in Hyderabad.",
      keywords: "school awards Hyderabad, education excellence award, recognized school Telangana, top CBSE school recognition"
    },
    program: {
      title: "Academic Programs | CBSE Curriculum | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "Comprehensive academic programs covering primary, middle, and high school with CBSE curriculum, science labs, sports, arts, and modern learning facilities.",
      keywords: "CBSE academic programs Hyderabad, primary school curriculum, middle school curriculum, high school education Telangana"
    },
    teachers: {
      title: "Experienced School Teachers | Qualified Faculty | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "Meet our qualified teachers and academic faculty dedicated to providing quality CBSE education, mentorship, and student success at THE ASIAN INTERNATIONAL SCHOOL.",
      keywords: "school teachers Hyderabad, qualified CBSE teachers, academic faculty Kukatpally, experienced educators Telangana"
    },
    gallery: {
      title: "School Gallery | Campus Life & Activities | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "Explore our gallery showcasing classroom learning, science labs, sports activities, cultural programs, and student life at THE ASIAN INTERNATIONAL SCHOOL.",
      keywords: "school gallery Hyderabad, student activities photos, school campus pictures, classroom learning Hyderabad"
    },
    faq: {
      title: "School FAQ | Admissions & Curriculum | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "Frequently asked questions about admissions, CBSE curriculum, facilities, and student life at THE ASIAN INTERNATIONAL SCHOOL in Kukatpally, Hyderabad.",
      keywords: "school admission FAQ Hyderabad, CBSE admission questions, school admission process Telangana"
    },
    contact: {
      title: "Contact THE ASIAN INTERNATIONAL SCHOOL | Admissions & Enquiries Hyderabad",
      description: "Contact THE ASIAN INTERNATIONAL SCHOOL in Kukatpally, Hyderabad for admissions, academic inquiries, campus visits, and school information.",
      keywords: "contact school Hyderabad, school admission Kukatpally, school location Telangana"
    },
    cbse: {
      title: "CBSE Curriculum | Academic Excellence | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "THE ASIAN INTERNATIONAL SCHOOL follows CBSE curriculum with focus on academic excellence, practical learning, innovation, and holistic student development.",
      keywords: "CBSE curriculum Hyderabad, CBSE school Kukatpally, CBSE education Telangana, academic excellence Hyderabad"
    },
    terms: {
      title: "Terms & Conditions | School Policies | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "Read the terms and conditions of THE ASIAN INTERNATIONAL SCHOOL including admission policies, school guidelines, and academic regulations.",
      keywords: "school terms conditions Hyderabad, admission policies school Telangana, school rules Hyderabad"
    },
    privacy: {
      title: "Privacy Policy | Student Data Protection | THE ASIAN INTERNATIONAL SCHOOL Hyderabad",
      description: "THE ASIAN INTERNATIONAL SCHOOL privacy policy explains how we protect student data, maintain confidentiality, and ensure secure information handling.",
      keywords: "school privacy policy Hyderabad, student data protection Telangana, privacy policy school"
    }
  },

  // Structured Data for SEO (JSON-LD)
  structuredData: {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    "name": "THE ASIAN INTERNATIONAL SCHOOL",
    "alternateName": "Asian International School",
    "description": "Leading CBSE school in Hyderabad providing quality primary, middle, and high school education with a focus on academic excellence, innovation, leadership, and holistic student development.",
    "url": "https://theasianinternationalschool.com",
    "logo": "https://theasianinternationalschool.com/logo.png",
    "image": "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&h=630&fit=crop&crop=center",
    "telephone": "+91-81069-21133",
    "email": "theasianinternationalschool@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "5-7-22/1, Sangeethnagar",
      "addressLocality": "Kukatpally",
      "addressRegion": "Telangana",
      "postalCode": "500072",
      "addressCountry": "IN"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "17.4948",
      "longitude": "78.4082"
    },
    "openingHours": "Mo-Fr 08:30-15:30",
    "priceRange": "$$",
    "curriculum": ["CBSE Curriculum", "STEM Education", "Holistic Learning"],
    "educationalCredentialAwarded": "Primary, Middle & High School Education",
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Academic Programs",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "Primary School (Grades 1-5)",
            "description": "Strong academic foundation with activity-based learning"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "Middle School (Grades 6-8)",
            "description": "Advanced subjects with analytical and practical learning"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Course",
            "name": "High School (Grades 9-10)",
            "description": "CBSE curriculum preparing students for board examinations"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "500",
      "bestRating": "5",
      "worstRating": "1"
    },
    "sameAs": [
      "https://facebook.com/theasianinternationalschool",
      "https://instagram.com/theasianinternationalschool",
      "https://twitter.com/theasianinternationalschool"
    ]
  },

  // Navigation Links
  navLinks: [
    { name: 'Home', path: '/', hasDropdown: false },
    { name: 'Academics', path: '/academics', hasDropdown: false },
    { name: 'CBSE', path: '/cbse', hasDropdown: false },
    { name: 'Programs', path: '/program', hasDropdown: false },
    { name: 'About', path: '/about', hasDropdown: false },
    { name: 'Gallery', path: '/gallery', hasDropdown: false },
    { name: 'Teachers', path: '/teachers', hasDropdown: false },
    { name: 'FAQ', path: '/faq', hasDropdown: false },
    { name: 'Contact', path: '/contact', hasDropdown: false },
  ],

  // Footer Links
  quickLinks: [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Programs', path: '/program' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Teachers', path: '/teachers' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact', path: '/contact' },
  ],

  programLinks: [
    { name: 'CBSE Curriculum', path: '/cbse' },
    { name: 'Primary School Program', path: '/program' },
    { name: 'Middle School Program', path: '/program' },
    { name: 'High School Program', path: '/program' },
    { name: 'Science & Digital Labs', path: '/program' },
    { name: 'Sports & Extracurricular Activities', path: '/program' },
  ]
};

export default settings;